'use strict';

exports.decode = exports.parse = require('./decode');
exports.encode = exports.stringify = require('./encode');



//////////////////
// WEBPACK FOOTER
// C:/Users/Paulo/Documents/Code/terra-alta-app/node_modules/querystring-es3/index.js
// module id = 79
// module chunks = 0